module.exports = __webpack_public_path__ + "static/media/home1.a7345e41.jpg";